<template>
   <div class="section section-news" id="section-news" v-if="news != null" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <div class="container">
            <div class="section-title-page">
                <h4>{{news.section}}</h4>
                <h2>{{news.title}}</h2>
            </div>
            <div class="number-of-section">
                <span>08</span>
            </div>
            <div class="column-container">
                <div class="col-left">
                    
                    <div class="logo-monaco">
                        <img :src="setup.logo_dark" alt="">
                    </div>
                    <div class="col-desc">
                        <p v-html="news.desc"></p>
                    </div>
                </div>
                <div class="col-right">
                    <div class="news-items" v-if="animate">
                        <div class="item" v-for="(item, index) in news.news_items" :key="index">
                            <div class="part">
                                <strong>{{index + 1}}-Я</strong>
                                <span>{{item.title}}</span>
                            </div>
                            <div class="ready-scale">
                                <div class="default-line"></div>
                                <div class="ready-line" :style="'width:' + ready[index].number + '%'"></div>
                            </div>
                            <div class="btn-open-news-info-modal">
                                <a href="#" class="btn btn-open-news-modal" 
                                    @click.prevent="openNewsModalInit(index)"
                                    :disabled="activity[index] == false" 
                                    >
                                    <span>Подробнее</span>
                                </a>
                            </div>
                            <div class="item-ready-number">
                                <h4>
                                    <animate-number 
                                        from="0" 
                                        :to="item.ready_number"
                                        duration="2000"  
                                        easing="easeOutQuad"
                                        :formatter="formatter"
                                    ></animate-number>
                                </h4>
                                <span>%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Новостная модалка -->
            <modal name="news-modal" 
                @before-close="beforeNewsModalClose" 
                @closed="newsModalClosed" 
                :transition="transitionName" 
                :width="modalWidth" 
                :height="modalHeight" 
                :scrollable="modalScrollable"                 
                id="news-modal">
                <newsModal :config="[{loading: loading, notVisible: notVisible, visible: visible, valueOption: valueOption}]"></newsModal>
            </modal>
        </div>
   </div>
</template>

<script>
    import newsModal from '@/components/news/news-modal.vue'
    export default {
        name: 'News',
        props: ['respond'],
        components: {
            newsModal,
        },
        data () {
            return {
                get: [
                    {
                        link: 'monaco_news_part_one'
                    },
                    {
                        link: 'monaco_news_part_two'
                    },
                    {
                        link: 'monaco_part_three'
                    }
                ],
                ready: [
                    {
                        number: 0
                    },
                    {
                        number: 0
                    },
                    {
                        number: 0
                    }
                ],
                valueOption: 0,
                visible: false,
                activity: [],
                loading: true,
                notVisible: true,
                animate: false,
                modalWidth: 1000,
                modalHeight: 'auto',
                modalScrollable: false,
                transitionName: 'pop-out',
                swiperOption: {
                    speed: 600,
                    observer: true,
                    observeParents: true,
                    spaceBetween: 20,
                    effect: 'slide',
                    navigation: {
                        nextEl: '.news-btn-next ',
                        prevEl: '.news-btn-prev',
                    }
                },
                intersectionOptions: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: [0.25,0.75]
                }
            }
        },
        computed: {
            news () {
                return this.$store.state.news
            },
            newsData() {
                return this.$store.state.newsData
            },
            setup() {
                return this.$store.state.pageSetup
            },
        },
        methods: {
            onWaypoint ({ el, going, direction }) {
                if (this.$waypointMap.GOING_IN === going) {
                    el.classList.add('animated-active');
                    this.animate = true;
                    this.setReadyNumber();
                }
            },
            formatter(num) {
                return num.toFixed();
            },
            initAminateNumber() {
                this.animate = false;
                setTimeout(()=>{
                    this.animate = true;
                },50);
            },
            setReadyNumber() {
                var i;
                setTimeout(()=>{
                    for (i=0; i < this.news.news_items.length; i++) {
                        this.ready[i].number = this.news.news_items[i].ready_number
                    }
                },300);
            },
            checkActivity () {
                var i;
                for (i = 0; i < this.news.news_items.length; i++) {
                    this.activity.push(this.news.news_items[i].btn_activity);
                }
                // console.log(this.activity);
            },  
            openNewsModalInit(index) {
                var _self = this;
                axios.get(window.newsUrl + window.GlobalLang + window.JsonUrl + this.get[index].link)
                .then((response) => {
                    if(response)
                    setTimeout(function(){
                        var select = $('#select-month'),
                            selectParent = $('.news-modal-info-selection-item');
                        select.selectric();
                        select.selectric({
                            onChange: function() {
                                _self.valueOption = $(this).val();
                            },
                            onOpen: function() {
                                selectParent.addClass('open');
                            },
                            onClose: function() {
                                selectParent.removeClass('open');  
                            }
                        });
                    },500);
                    setTimeout(function(){
                        _self.notVisible = false;
                        _self.loading = false;
                    },800);
                    this.visible = true;
                    this.$store.dispatch('clearNewsData');
                    var i;
                    for (i = 0; i < response.data.length; i++) {
                        this.$store.commit('newsData', response.data[i].acf);
                    }
                });
                this.$modal.show('news-modal');
                document.getElementById('secret-btns').classList.remove('fadeIn');
            },
            beforeNewsModalClose() {
                this.notVisible = true;
            },
            newsModalClosed() {
                this.loading = true;
                this.valueOption = 0;
                document.getElementById('secret-btns').classList.add('fadeIn');
            },
            settingsNewsModal() {
				var _self = this;
				if ($(window).width() > 1024) {
					_self.modalWidth = 1000;
					_self.modalHeight = 'auto';
					_self.transitionName = 'pop-out';
				} else {
					_self.modalWidth = 100;
					_self.modalHeight = 'auto';
					_self.modalScroll = true;
					_self.transitionName = 'fade-enter';
				}
			},
			handleResize() {
                var _self = this;
                if (window.innerWidth >= 1024) {
                    _self.modalWidth = 1000;
					_self.modalHeight = 'auto';
                } else {
					_self.modalScroll = true;
					_self.modalHeight = 'auto';
				}
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        mounted () {
            this.$store.watch(
                (state) => state.news,
                (newValue) => {
                    if (newValue)
                    this.checkActivity();
                    this.settingsNewsModal();
                    this.checkResize();
                }
            )
        }
    } 
</script>

<style lang="scss" scoped>
    @import '@/styles/components/news/news.scss';
    @import '@/styles/components/news/news-modal.scss';
    @import '@/styles/components/news/news-respond/news-respond.scss';
    // @import '@/styles/components/animation/animation-news.scss';
</style>